<form [formGroup]="filterForm">
  <div style="display: flex; flex-wrap: wrap; gap: 10px">
    <div class="div-champ-filtre">
      <!-- Agent filter -->
      <div class="div-field">
        <mat-form-field class="field-filtre field-filtre-text" floatLabel="always">
          <mat-label>Agent</mat-label>
          <input
            type="text"
            aria-label="Agent"
            matInput
            name="agent"
            [matAutocomplete]="agentAuto"
            formControlName="agent"
            (input)="agentFilter($event)"
            />
            @if (this.filterForm.get('agent')?.value) {
              <button
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="clearAgentFilter($event)"
                >
                <mat-icon>close</mat-icon>
              </button>
            }
            <mat-autocomplete #agentAuto="matAutocomplete" hideSingleSelectionIndicator requireSelection [displayWith]="agentDisplayFn">
              @for (agent of filteredAgents; track agent) {
                <mat-option [value]="agent"> {{ agent.nom }} {{ agent.prenom }} </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <!-- Direction -->
        <div class="div-field">
          <mat-form-field class="field-filtre field-filtre-text" floatLabel="always">
            <mat-label>Direction</mat-label>
            <input
              type="text"
              aria-label="direction"
              matInput
              name="direction"
              [matAutocomplete]="directionAuto"
              formControlName="direction"
              (input)="directionFilter($event)"
              />
              @if (this.filterForm.get('direction')?.value) {
                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearDirectionFilter($event)"
                  >
                  <mat-icon>close</mat-icon>
                </button>
              }
              <mat-autocomplete
                #directionAuto="matAutocomplete"
                hideSingleSelectionIndicator
                requireSelection
                [displayWith]="directionDisplayFn"
                >
                @for (direction of filteredDirection; track direction) {
                  <mat-option [value]="direction"> {{ direction.libelle }} </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <!-- Service -->
          <div class="div-field">
            <mat-form-field class="field-filtre field-filtre-text" floatLabel="always">
              <mat-label>Service</mat-label>
              <input
                type="text"
                aria-label="Service"
                matInput
                name="service"
                [matAutocomplete]="serviceAuto"
                formControlName="service"
                (input)="serviceFilter($event)"
                />
                @if (this.filterForm.get('service')?.value) {
                  <button
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="clearInfoServiceFilter($event)"
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                }
                <mat-autocomplete #serviceAuto="matAutocomplete" hideSingleSelectionIndicator requireSelection [displayWith]="serviceDisplayFn">
                  @for (service of filteredServices; track service) {
                    <mat-option [value]="service"> {{ service.libelle }} </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>

            <!-- Structure filter -->
            <div class="div-field">
              <mat-form-field class="field-filtre field-filtre-text" floatLabel="always">
                <mat-label>Structure</mat-label>
                <input type="text" matInput formControlName="structureHierarchique" />
                @if (this.filterForm.get('structureHierarchique')?.value) {
                  <button
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="clearStructureHierarchiqueFilter($event)"
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
            </div>

            <!-- Matricule Agent filter -->
            <div class="div-field">
              <mat-form-field class="field-filtre field-filtre-text" floatLabel="always">
                <mat-label>Matricule de l'agent</mat-label>
                <input type="text" matInput formControlName="matriculeAgent" />
                @if (this.filterForm.get('matriculeAgent')?.value) {
                  <button
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="clearMatriculeFilter($event)"
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
            </div>

            <!-- Intitulé du poste -->
            <div class="div-field">
              <mat-form-field class="field-filtre field-filtre-text" floatLabel="always">
                <mat-label>Intitulé du poste</mat-label>
                <input
                  type="text"
                  aria-label="Intitule poste"
                  matInput
                  name="intitulePoste"
                  [matAutocomplete]="posteAuto"
                  formControlName="intitulePoste"
                  (input)="infoPosteFilter($event)"
                  />
                  @if (this.filterForm.get('intitulePoste')?.value) {
                    <button
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="clearInfoPosteFilter($event)"
                      >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                  <mat-autocomplete #posteAuto="matAutocomplete" hideSingleSelectionIndicator requireSelection [displayWith]="infoPosteDisplayFn">
                    @for (poste of filteredPostes; track poste) {
                      <mat-option [value]="poste">{{ poste.libelle }}</mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>

              <!-- Numero de poste -->
              <div class="div-field">
                <mat-form-field class="field-filtre field-filtre-text" floatLabel="always">
                  <mat-label>Numéro de poste</mat-label>
                  <input
                    type="text"
                    aria-label="Numéro poste"
                    matInput
                    name="numeroPoste"
                    [matAutocomplete]="numPosteAuto"
                    formControlName="numeroPoste"
                    (input)="infoPosteFilter($event)"
                    />
                    @if (this.filterForm.get('numeroPoste')?.value) {
                      <button
                        matSuffix
                        mat-icon-button
                        aria-label="Clear"
                        (click)="clearNumPosteFilter($event)"
                        >
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                    <mat-autocomplete
                      #numPosteAuto="matAutocomplete"
                      hideSingleSelectionIndicator
                      requireSelection
                      [displayWith]="numeroPosteDisplayFn"
                      >
                      @for (poste of filteredPostes; track poste) {
                        <mat-option [value]="poste">{{ poste.code }}</mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>

                <!-- Poste budgété-->
                <div class="div-field">
                  <mat-form-field class="field-filtre field-filtre-select" floatLabel="always">
                    <mat-label>Poste budgété 2025</mat-label>
                    <mat-select formControlName="posteBudgete">
                      <mat-option [value]="true">Oui</mat-option>
                      <mat-option [value]="false">Non</mat-option>
                    </mat-select>
                    @if (this.filterForm.get('posteBudgete')?.value !== null && this.filterForm.get('posteBudgete')?.value !== '') {
                      <button
                        matSuffix
                        mat-icon-button
                        aria-label="Clear"
                        (click)="clearPosteBudgeteFilter($event)"
                        >
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                  </mat-form-field>
                </div>
                <!-- Vacant Pourvu-->
                <div class="div-field">
                  <mat-form-field class="field-filtre field-filtre-select" floatLabel="always">
                    <mat-label>Vacant ou Pourvu</mat-label>
                    <mat-select formControlName="vacantPourvu">
                      <mat-option [value]="'Vacant'">Vacant</mat-option>
                      <mat-option [value]="'Pourvu'">Pourvu</mat-option>
                    </mat-select>
                    @if (this.filterForm.get('vacantPourvu')?.value !== null && this.filterForm.get('vacantPourvu')?.value !== '') {
                      <button
                        matSuffix
                        mat-icon-button
                        aria-label="Clear"
                        (click)="clearVpFilter($event)"
                        >
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                  </mat-form-field>
                </div>

                <!-- Age de l'agent filter -->
                <div class="div-field">
                  <mat-form-field class="field-filtre field-filtre-text" floatLabel="always">
                    <mat-label>Age de l'agent</mat-label>
                    <input type="text" matInput formControlName="ageAgent" />
                    @if (this.filterForm.get('ageAgent')?.value) {
                      <button
                        matSuffix
                        mat-icon-button
                        aria-label="Clear"
                        (click)="clearAgeAgentnFilter($event)"
                        >
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                  </mat-form-field>
                </div>
                <!-- Fonction filter -->
                <div class="div-field">
                  <mat-form-field class="field-filtre field-filtre-text" floatLabel="always">
                    <mat-label>Fonction</mat-label>
                    <input type="text" matInput formControlName="fonction" />
                    @if (this.filterForm.get('fonction')?.value) {
                      <button
                        matSuffix
                        mat-icon-button
                        aria-label="Clear"
                        (click)="clearFonctionFilter($event)"
                        >
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                  </mat-form-field>
                </div>

                <!-- Taux Emploi Filter -->
                <div class="div-field">
                  <mat-form-field class="field-filtre field-filtre-text" floatLabel="always">
                    <mat-label>Taux d'emploi</mat-label>
                    <input type="text" matInput formControlName="tauxEmploi" />
                    @if (this.filterForm.get('tauxEmploi')?.value) {
                      <button
                        matSuffix
                        mat-icon-button
                        aria-label="Clear"
                        (click)="clearTauxEmploiFilter($event)"
                        >
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                  </mat-form-field>
                </div>
                <!-- Agent remplacé Filter -->
                <div class="div-field">
                  <mat-form-field class="field-filtre field-filtre-text" floatLabel="always">
                    <mat-label>Agent remplacé</mat-label>
                    <input
                      type="text"
                      aria-label="Agent remplacé"
                      matInput
                      name="agentRemplace"
                      [matAutocomplete]="agentRemplaceAuto"
                      formControlName="agentRemplace"
                      (input)="agentRemplaceFilter($event)"
                      />
                      @if (this.filterForm.get('agentRemplace')?.value) {
                        <button
                          matSuffix
                          mat-icon-button
                          aria-label="Clear"
                          (click)="clearAgentRemplaceFilter($event)"
                          >
                          <mat-icon>close</mat-icon>
                        </button>
                      }
                      <mat-autocomplete
                        #agentRemplaceAuto="matAutocomplete"
                        hideSingleSelectionIndicator
                        requireSelection
                        [displayWith]="agentRemplaceDisplayFn"
                        >
                        @for (agent of filteredAgentsRemplaces; track agent) {
                          <mat-option [value]="agent">{{ agent.nom }} {{ agent.prenom }}</mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>

                  <!-- Catégorie poste Filter -->
                  <div class="div-field">
                    <mat-form-field class="field-filtre field-filtre-select" floatLabel="always">
                      <mat-label>Catégorie grade</mat-label>
                      <mat-select formControlName="categoriePoste">
                        @for (categorie of categoriePosteList; track categorie) {
                          <mat-option [value]="categorie">{{ categorie.code }}</mat-option>
                        }
                      </mat-select>
                      @if (this.filterForm.get('categoriePoste')?.value) {
                        <button
                          matSuffix
                          mat-icon-button
                          aria-label="Clear"
                          (click)="clearCategoriePosteFilter($event)"
                          >
                          <mat-icon>close</mat-icon>
                        </button>
                      }
                    </mat-form-field>
                  </div>

                  <!-- Type CT Filter -->
                  <div class="div-field">
                    <mat-form-field class="field-filtre field-filtre-select" floatLabel="always">
                      <mat-label>Type contrat</mat-label>
                      <mat-select formControlName="typeCT">
                        @for (type of typeContratList; track type) {
                          <mat-option [value]="type">{{ type.libelle }}</mat-option>
                        }
                      </mat-select>
                      @if (this.filterForm.get('typeCT')?.value) {
                        <button
                          matSuffix
                          mat-icon-button
                          aria-label="Clear"
                          (click)="clearTypeCTFilter($event)"
                          >
                          <mat-icon>close</mat-icon>
                        </button>
                      }
                    </mat-form-field>
                  </div>

                  <!-- Date début de contrat Filter -->
                  <div class="div-field">
                    <mat-form-field class="field-filtre" floatLabel="always">
                      <mat-label>Date début contrat</mat-label>
                      <input
                        type="text"
                        formControlName="dateDebutContrat"
                        appearance="standard"
                        matInput
                        [matDatepicker]="pickerDateDebut"
                        placeholder="dd/mm/yyyy"
                        />
                        <mat-datepicker-toggle matIconSuffix [for]="pickerDateDebut"></mat-datepicker-toggle>
                        <mat-datepicker #pickerDateDebut></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <!-- Date fin de contrat Filter -->
                    <div class="div-field">
                      <mat-form-field class="field-filtre" floatLabel="always">
                        <mat-label>Date fin contrat</mat-label>
                        <input
                          type="text"
                          formControlName="dateFinContrat"
                          appearance="standard"
                          matInput
                          [matDatepicker]="pickerDateFin"
                          placeholder="dd/mm/yyyy"
                          />
                          <mat-datepicker-toggle matIconSuffix [for]="pickerDateFin"></mat-datepicker-toggle>
                          <mat-datepicker #pickerDateFin></mat-datepicker>
                        </mat-form-field>
                      </div>

                      <!-- Nombre agent Filter -->
                      <div class="div-field">
                        <mat-form-field class="field-filtre field-filtre-text" floatLabel="always">
                          <mat-label>Nombre agent sur poste</mat-label>
                          <input type="text" matInput formControlName="nombreAgent" />
                          @if (this.filterForm.get('nombreAgent')?.value) {
                            <button
                              matSuffix
                              mat-icon-button
                              aria-label="Clear"
                              (click)="clearNombreAgentFilter($event)"
                              >
                              <mat-icon>close</mat-icon>
                            </button>
                          }
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="div-filtre-bouton" style="margin-left: 10px">
                      <button mat-stroked-button type="reset" class="mr-5 bt-table-effacer" (click)="resetForm()" style="height: 40px">
                        <mat-icon>delete</mat-icon> Effacer tous les filtres
                      </button>
                      <button mat-raised-button color="primary" class="mr-5 bt-table-filtrer" (click)="applyFilters()" style="height: 40px; width: 100px">
                        Filtrer
                      </button>
                    </div>
                  </div>
                </form>
